import { LayerProps } from "react-map-gl/maplibre";
import { LineSimpleConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getLineSimpleStyles = ({
	symbolStyle,
}: LineSimpleConfigs): LayerProps[] => {
	const styles: LayerProps[] = [];

	// Fill
	if (symbolStyle?.fill?.style === "solid") {
		styles.push({
			id: "solid-fill-filling",
			type: "line",
			layout: {
				// "line-cap": "round",
				// "line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.fill?.color ?? "#000000",
				"line-width": symbolStyle?.fill?.width ?? 0,
				"line-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.fill?.style === "dash") {
		styles.push({
			id: "dash-fill-casing",
			type: "line",
			layout: {
				// "line-cap": "round",
				// "line-join": "round",
			},
			paint: {
				"line-color": "#000000",
				"line-width": (symbolStyle?.fill?.width ?? 0) * 1.25,
				"line-dasharray": [1, 0.3],
				"line-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.fill?.style === "dot") {
		styles.push({
			id: "dot-fill-casing",
			type: "line",
			layout: {},
			paint: {
				"line-color": symbolStyle?.fill?.color ?? "#000000",
				"line-width": (symbolStyle?.fill?.width ?? 0) * 1.25,
				"line-opacity": symbolStyle?.fill?.opacity ?? 1,
				"line-dasharray": [0.5, 0.5],
			},
		});
	}

	// Stroke
	if (symbolStyle?.stroke?.style == "solid") {
		styles.push({
			id: "solid-stroke-casing",
			type: "line",
			layout: {
				"line-cap": "round",
				"line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 1,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.stroke?.style == "dash") {
		const width = symbolStyle?.stroke?.width ?? 0;

		styles.push({
			id: "dash-stroke-casing",
			type: "line",
			layout: {
				// "line-cap": "round",
				// "line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": width,
				"line-dasharray": [1, 0.25],
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.stroke?.style === "dot") {
		const width = symbolStyle?.stroke?.width ?? 0;

		styles.push({
			id: "dot-stroke-casing",
			type: "line",
			layout: {},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": width,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				"line-dasharray": [0.5, 0.5],
			},
		});
	}

	return styles;
};
